import { useEffect, useRef, useLayoutEffect, useState } from "react";
import {
  Vector,
  Events,
  Mouse,
  Body,
  Matter,
  Engine,
  Render,
  Bodies,
  Composite,
} from "matter-js";
import Fruits from "./Fruits";

const Pachinko = ({externalSize = {width:0,height:0}})=> {
  const sceneRef = useRef(null);
  const isPressed = useRef(false);
  const engineRef = useRef(null);
  const renderRef = useRef(null);
  const mouseRef = useRef(null);
  const matterWidth = 350;
  const matterHeight = 430;

  const playAreaWidth = 350;
  const playAreaHeight = 430;

  var defaultCategory = 0x0001, // for walls
    fruitCategory = 0x0002, // red circles
    ghostCategory = 0x0004; // yellow circles

  const [hasClicked, setClicked] = useState(false);
  const [showWireframes, setShowWireframes] = useState(false);
  const [isHovering, setHovering] = useState(false);

  //const fruitCooldown = 0.33;//seconds
  const fruitCooldown = 0.1; //seconds
  const [canDrop, setCanDrop] = useState(true);
  const nextFruitRef = useRef(null);

  const createPlayArea = () => {
    let midpointX = matterWidth / 2;
    let midpointY = matterHeight / 2;
    var wallOptions = {
      collisionFilter: {
        category: defaultCategory,
      },
      isStatic: true,
    };
    Composite.add(engineRef.current.world, [
      Bodies.rectangle(
        midpointX,
        midpointY - playAreaHeight / 2 - 10,
        playAreaWidth,
        20,
        wallOptions
      ),
      Bodies.rectangle(
        midpointX,
        midpointY + playAreaHeight / 2 + 10,
        playAreaWidth,
        20,
        wallOptions
      ),
      Bodies.rectangle(
        midpointX - playAreaWidth / 2 - 10,
        midpointY,
        20,
        playAreaHeight,
        wallOptions
      ),
      Bodies.rectangle(
        midpointX + playAreaWidth / 2 + 10,
        midpointY,
        20,
        playAreaHeight,
        wallOptions
      ),
    ]);
  };

  // engineRef.current.world.gravity.y = 0.3;

  useEffect(() => {
    // Clean up the existing engine before creating a new one
    if (engineRef.current) {
      Composite.clear(engineRef.current.world, true);
      Engine.clear(engineRef.current);
      nextFruitRef.current = null;
    }

    const newEngine = Engine.create();
    engineRef.current = newEngine;

    let engine = engineRef.current;
    let composite = engine.world;
    let scene = sceneRef.current;
    let fruitsToAdd = [];

    const render = scene
      ? Render.create({
          element: scene,
          engine: engine,
          options: {
            width: matterWidth,
            height: matterHeight,
            wireframes: showWireframes,
          },
        })
      : null;

    renderRef.current = render;

    mouseRef.current = Mouse.create(render.canvas);

    if (nextFruitRef.current == null) {
      generateNewGhost();
    }

    createPlayArea();

    Events.on(engine, "collisionStart", function (event) {
      let pairs = event.pairs;
      let alreadyProcessedIds = [];
      for (let i = 0; i < pairs.length; i++) {
        let pair = pairs[i];

        // Check if the collision involves circle bodies
        if (
          pair.bodyA.isFruit &&
          pair.bodyB.isFruit &&
          pair.bodyA.name === pair.bodyB.name
        ) {
          //ignore the watermelon index so two watermelons will not combine.
          //Don't try to create new fruits for collisions already made.
          if (
            pair.bodyA.name === Fruits[Fruits.length - 1].name ||
            alreadyProcessedIds.includes(pair.bodyA.id) ||
            alreadyProcessedIds.includes(pair.bodyB.id)
          ) {
            console.log("CRISIS AVERTED");
            continue;
          }

          let nextFruitIndex = Fruits.findIndex(
            (f) => f.name === pair.bodyA.name
          );
          console.log("FRUIT INDEX");
          if (nextFruitIndex !== -1) {
            nextFruitIndex++;
            var midpointX = (pair.bodyA.position.x + pair.bodyB.position.x) / 2;
            var midpointY = (pair.bodyA.position.y + pair.bodyB.position.y) / 2;
            let fruitToAdd = createFruitBody(
              midpointX,
              midpointY,
              Fruits[nextFruitIndex]
            );
            fruitsToAdd.push(fruitToAdd);
          }

          Composite.remove(composite, pair.bodyA);
          Composite.remove(composite, pair.bodyB);
        }
      }
    });

    // Listen for the "beforeUpdate" event
    Events.on(engine, "beforeUpdate", function (event) {
      // Iterate through all bodies in the world
      for (let i = 0; i < composite.bodies.length; i++) {
        let body = composite.bodies[i];
        //out of bounds check
        if (
          body.position.x > matterWidth + 100 ||
          body.position.x < -100 ||
          body.position.y > matterHeight + 100 ||
          body.position.y < -100
        ) {
          Composite.remove(composite, body);
        }
      }

      //Queue any collisions where you need to add fruit.
      if (fruitsToAdd.length > 0) {
        for (var i = 0; i < fruitsToAdd.length; i++) {
          let currentFruit = fruitsToAdd[i];
          Composite.add(composite, currentFruit);
        }
        fruitsToAdd = [];
      }
    });

    // Attach the mousemove event listener
    // sceneRef.current.addEventListener("mousemove", (event) => {
    //   let scale = getSceneScale();
    //   Body.setPosition(nextFruitRef.current, {
    //     x: mouseRef.current.position.x / scale,
    //     y: mouseRef.current.position.y / scale,
    //   });
    // });

    console.log("RENDER CANVAS??");
    console.log(render.canvas);

    // Composite.add(engine.current.world);
    const fixedDelta = 16.67;
    let accumulatedTime = 0;
    let lastTime;
    let seconds = 0;
    let frames = 0;
    const update = (time) => {
      if (lastTime) {
        const deltaTime = time - lastTime;
        accumulatedTime += deltaTime;

        while (accumulatedTime >= fixedDelta) {
          frames++;
          if (frames >= 60) {
            frames = 0;
            seconds++;
          }
          // Update the physics engine with fixed timestep
          Engine.update(engine, fixedDelta);
          accumulatedTime -= fixedDelta;

          // Render the scene
          if (scene) {
            try {
              Render.world(render);
            } catch (e) {}
          }
        }
      }

      lastTime = time;
      requestAnimationFrame(update);
    };

    requestAnimationFrame(update);

    // Function to scale the scene


    // // Initial scale
    scaleScene();

    window.addEventListener("resize", scaleScene);

    return () => {
      Render.stop(render);
      Composite.clear(newEngine.world);
      Engine.clear(newEngine);
      window.removeEventListener("resize", scaleScene);
      if (render && render.canvas) {
        render.canvas.remove();
        render.canvas = null;
        render.context = null;
        render.textures = {};
      }
    };
  }, [matterWidth, matterHeight]);

  useEffect(() => {
    scaleScene();
  }, [externalSize]);


  const scaleScene = () => {
    let scale = getSceneScale();
    if (renderRef.current == null || renderRef.current.canvas == null) {
      return;
    }

    // Apply scale transformation
    Render.lookAt(renderRef.current, {
      min: { x: 0, y: 0 },
      max: { x: 350, y: 430 },
    });

    renderRef.current.canvas.style.transform = `scale(${scale})`;
    renderRef.current.canvas.style.transformOrigin = "top left";
    sceneRef.current.transform = `scale(${scale})`;

  };

  const handleDown = (e) => {
    isPressed.current = true;
    if (hasClicked === false) {
      setClicked(true);
      handleAddCircle(e);
    }
  };

  const getSceneScale = () => {
    if (sceneRef.current.clientWidth == null){
      return 1;
    } 
    const scaleX = sceneRef.current.clientWidth / matterWidth;
    const scaleY = sceneRef.current.clientHeight / matterHeight;
    const scale = Math.min(scaleX, scaleY);
    return scale;
  };

  const handleUp = () => {
    isPressed.current = false;
    if (hasClicked === true) {
      setClicked(false);
    }
  };
  const handleMatterEnter = () => {
    setHovering(true);
  };
  const handleMatterLeave = () => {
    setHovering(false);
  };

  const createFruitBody = (x, y, fruit) => {
    const ball = Bodies.circle(x, y, fruit.radius, {
      mass: 0.1,
      restitution: 0.9,
      friction: 0,
      render: {
        fillStyle: fruit.color,
      },
    });
    ball.name = fruit.name;
    ball.isFruit = true;
    return ball;
  };
  const getRandomFruit = () => {
    let randomFruit = Fruits[Math.floor(Math.random() * 5)];
    return randomFruit;
  };

  const generateNewGhost = () => {
    let scale = getSceneScale();
    nextFruitRef.current = createFruitBody(
      mouseRef.current.position.x / scale,
      mouseRef.current.position.y / scale,
      getRandomFruit()
    );
    Body.setStatic(nextFruitRef.current, true);
    let newCollisionFilter = {
      category: defaultCategory,
    };
    Body.set(nextFruitRef.current, "collisionFilter", newCollisionFilter);
    Composite.add(engineRef.current.world, [nextFruitRef.current]);
  };
  const dropGhost = () => {
    Body.setStatic(nextFruitRef.current, false);
    console.log(nextFruitRef.current);
    let newCollisionFilter = {
      group: 1,
      category: defaultCategory,
      mask: defaultCategory,
    };
    Body.set(nextFruitRef.current, "collisionFilter", newCollisionFilter);
  };

  const handleAddCircle = (e) => {
    if (
      !isHovering ||
      mouseRef.current.position.x >= matterWidth ||
      mouseRef.current.position.x <= 0 ||
      mouseRef.current.position.y >= matterHeight ||
      mouseRef.current.position.y <= 0
    ) {
      console.log("OUT OF BOUDNS");
      return;
    }

    if (canDrop) {
      setCanDrop(false);
      setTimeout(() => {
        setCanDrop(true);
      }, 1000 * fruitCooldown);
    } else {
      return;
    }

    dropGhost();
    generateNewGhost();
  };
  const handleClear = () => {
    Composite.clear(engineRef.current.world);
    createPlayArea();
  };
  const handleStatus = () => {
    console.log("bodies count: " + engineRef.current.world.bodies.length);
  };

  return (
      <div
        onMouseDown={handleDown}
        onMouseUp={handleUp}
        onMouseEnter={handleMatterEnter}
        onMouseLeave={handleMatterLeave}
        ref={sceneRef}
      />
  );
}

export default Pachinko;
